'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pickAssign = exports.testAlwaysTrue = exports.testPickPropsOnComponent = exports.testPickPropsOnStringTag = exports.themeChannel = undefined;
exports.setFrame = setFrame;
exports.setTheme = setTheme;

var _isPropValid = require('@helpscout/react-utils/dist/isPropValid');

var _isPropValid2 = _interopRequireDefault(_isPropValid);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var themeChannel = exports.themeChannel = '__EMOTION_THEMING__';
/**
 * Sets the Frame (document) supplied by the FrameProvider
 * @param {*} frame
 */

function setFrame(frame) {
  this.setState({
    frame: frame
  });
}

function setTheme(theme) {
  this.setState({
    theme: theme
  });
}

var testPickPropsOnStringTag = exports.testPickPropsOnStringTag = _isPropValid2.default;

var testPickPropsOnComponent = exports.testPickPropsOnComponent = function (key) {
  return key !== 'theme' && key !== 'innerRef';
};

var testAlwaysTrue = exports.testAlwaysTrue = function () {
  return true;
};

var pickAssign = exports.pickAssign = function (testFn, target) {
  var i = 2;
  var length = arguments.length;

  for (; i < length; i++) {
    var source = arguments[i];

    var _key = void 0;

    for (_key in source) {
      /* istanbul ignore else */
      if (testFn(_key)) {
        target[_key] = source[_key];
      }
    }
  }

  return target;
};